import { KeyIcon } from "@heroicons/react/24/outline";

import { FlagIcon } from "@heroicons/react/24/outline";
import { formatBehaviorDisplay, isPositiveBehavior } from "./util";

interface ItemFlagsProps {
  keywordFlags: string[];
  behaviorFlags: string[];
}

export default function ItemFlags({
  keywordFlags,
  behaviorFlags,
}: ItemFlagsProps) {
  function BehaviorFlagChip({ behaviorFlag }: { behaviorFlag: string }) {
    const bgColor = isPositiveBehavior(behaviorFlag)
      ? "bg-[#41B373]"
      : "bg-[#F48503]";
    return (
      <span
        key={behaviorFlag}
        className={`inline-flex items-center px-2 min-h-[30px] text-xs tracking-wide text-white rounded ${bgColor}`}
      >
        {formatBehaviorDisplay(behaviorFlag)}
      </span>
    );
  }

  function KeywordChip({ keyword }: { keyword: string }) {
    return (
      <span
        key={keyword}
        className="inline-flex items-center px-2 min-h-[30px] text-xs tracking-wide text-gray-600 border border-gray-200 rounded"
      >
        {keyword}
      </span>
    );
  }

  return (
    <div className="space-y-2">
      {behaviorFlags.length > 0 && (
        <section className="flex flex-wrap items-center gap-2">
          <FlagIcon className="w-4 h-4 text-[#126798]" />
          <div className="flex flex-wrap gap-2">
            {behaviorFlags.map((behavior) => (
              <BehaviorFlagChip key={behavior} behaviorFlag={behavior} />
            ))}
          </div>
        </section>
      )}

      {keywordFlags.length > 0 && (
        <section className="flex flex-wrap items-center gap-2">
          <KeyIcon className="w-4 h-4 text-[#126798]" />
          <div className="flex flex-wrap gap-2">
            {keywordFlags.map((keyword) => (
              <KeywordChip key={keyword} keyword={keyword} />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
